import Vue from 'vue'
import { debounce } from 'lodash'
import mergeWith from 'lodash/mergeWith'

import { userService } from '@/service/user.service'

const initialState = {
    mapDisplayPreferences: {
        activeTileProviderId: null,
        clusteringEnabled: true,
        displayDriverName: true,
        displayRemainingTime: true,
        liveUpdatesEnabled: true,
        shouldZoomToFit: true,
        showAccuracy: false,
        showLabels: false,
        showLocations: true,
        showMarkersInGeofences: true,
        simpleMarkersEnabled: false,
        smallerMarkersEnabled: false,
    },
    assetListFilterPreferences: {
        filterByColor: [],
        filterByInactive: false,
        filterByLocation: [],
        filterByType: [],
        filterByAlert: false,
        filterByRecentlyActive: false,
        lastActiveFor: 21600000, // ms
        sortBy: 1,
        search: '',
    },
    axRoadTrucksListPreferences: {},
    axRoadDriversListPreferences: {},
    axRoadPreferences: {
        hiddenAssetTypes: [],
    },
    userInteractionPreferences: {
        hideOnboardingPopups: false,
        hideLsvaOverviewOnboardingPopup: false,
    },
    isAssetFilterActive: false,
}

const state = {
    ...initialState,
    isPristine: true,
}

const getters = {
    mapDisplayPreferences: state => state.mapDisplayPreferences,
    assetListFilterPreferences: state => state.assetListFilterPreferences,
    axRoadTrucksListPreferences: state => state.axRoadTrucksListPreferences,
    axRoadDriversListPreferences: state => state.axRoadDriversListPreferences,
    axRoadPreferences: state => state.axRoadPreferences,
    userInteractionPreferences: state => state.userInteractionPreferences,
}

const actions = {
    async fetchPreferences({ commit, rootGetters }) {
        const currentUserId = rootGetters['auth/getCurrentUserId']
        commit('setPreferences', initialState)
        commit('setPristine', true)
        const { preferences } = await userService.fetchUserInfo(currentUserId)
        commit('setPreferences', preferences)
    },
    savePreferences: debounce(async ({ state, commit, rootGetters }) => {
        if (state.isPristine) {
            return
        }
        const currentUserId = rootGetters['auth/getCurrentUserId']
        commit('setPristine', true)
        await userService.updateUserInfo(currentUserId, { preferences: state })
    }, 1000),
    updatePreferences({ commit, dispatch }, preferences) {
        commit('setPreferences', preferences)
        commit('setPristine', false)
        dispatch('savePreferences')
    },
}

const mutations = {
    setPristine(state, isPristine) {
        state.isPristine = isPristine
    },
    setPreferences(state, preferences) {
        mergeWith(state, preferences || {}, (objValue, srcValue) => {
            if (Array.isArray(objValue) && Array.isArray(srcValue)) {
                return srcValue
            }
            return undefined
        })
        for (const key in preferences || {}) {
            Vue.set(state, key, state[key])
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
